import React from 'react';
import { NavLink } from 'react-router-dom';
import './style.scss';

const MyBiyesadi = () => {
  const links = [
    { to: '/my-dashbord/', label: 'Dashboard' },
    { to: '/my-dashbord/profile', label: 'Profile' },
    { to: '/my-dashbord/photos', label: 'Photo' },
    { to: '/my-dashbord/partner-preference', label: 'Partner Preference' },
    { to: '/my-dashbord/settings', label: 'Settings' },
    { to: '/my-dashbord/contact', label: 'Contact Details' },
    { to: '/my-dashbord/package', label: 'Packages' },
    { to: '/my-dashbord/paymentlog', label: 'Payment Log' },
  ];

  return (
    <div className="custom-navbar">
      <div className="container">
        <div className="row">
          <div className="col-12 d-flex flex-wrap justify-content-start gap-2">
            {links.map((link, index) => (
              <NavLink
                key={index}
                to={link.to}
                className={({ isActive }) =>
                  isActive ? 'btn  isActive' : 'btn '
                }
              >
                {link.label}
              </NavLink>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyBiyesadi;
